









































































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {
  GeceKosusuOrtamListesi,
  KosuDetay,
  KosuHataSatiri,
  KosuTenantSatiri,
  formatDateTime,
  geceKosusuOrtamlari,
  hataTipiEtiketi,
  veriEksikTipiMi,
  kosuDurumBilgisi,
  ortamBul,
  tenantDurumBilgisi,
  tenantGoruntuAdi,
  sureMetni,
  tahminMetni,
  yuzde
} from "@/entity/GeceKosusuEntity";

/**
 * Yoklama gecikme basamakları (ms). İlk basamak istenen normal aralık (5 sn);
 * sonrakiler hata/429 sonrası üstel geri çekilme — TenantHavuzu.vue'daki
 * tekniğin (basamak dizisi + Retry-After + görünürlük durdurma) aynısı,
 * yalnızca burada normal aralık 5 sn olduğu için basamaklar ona göre kurulu.
 */
const GECIKME_BASAMAKLARI = [5000, 10000, 20000, 40000, 60000];

/** `Retry-After` saniye cinsinden gelirse üst sınır (ms). */
const AZAMI_RETRY_AFTER = 300000;

/** Hata tipi -> chip rengi. Entity yalnızca etiketi verir, renk ekrana özgü. */
const HATA_TIPI_RENK: { [key: string]: string } = {
  timeout: "warning",
  read_only: "error",
  deadlock: "error",
  lock_timeout: "warning",
  tenant_genel: "error",
  genel: "error",
  alacak_yok: "blue-grey",
  takip_tarihi_yok: "blue-grey",
  veri_eksik: "blue-grey"
};

/** Bir tenant'ın hata listesi için ekran durumu (yükleniyor / önbellek / sayfalama). */
interface TenantHataDurumu {
  yukleniyor: boolean;
  yukleniyorDaha: boolean;
  hata: string;
  liste: KosuHataSatiri[];
  sayfa: number;
  dahaVar: boolean;
  /** En az bir kez başarıyla yüklendi mi — önbellek kontrolü için. */
  yuklendi: boolean;
  /** Bu tenant için uçuştaki isteği bayatlatmak amacıyla artan sıra numarası. */
  sira: number;
}

const BOS_HATA_DURUM: TenantHataDurumu = {
  yukleniyor: false, yukleniyorDaha: false, hata: "", liste: [],
  sayfa: 0, dahaVar: false, yuklendi: false, sira: 0
};

@Component
export default class GeceKosusuDetay extends Vue {
  kosuId: number | null = null;
  detay: KosuDetay | null = null;
  yukleniyor: boolean = false;
  yuklemeHatasi: string = "";
  bulunamadi: boolean = false;

  /** Derleme ayarından gelen ortam listesi; seçili ortam rotadaki ?ortam= sorgusundan okunur. */
  ortamListesi: GeceKosusuOrtamListesi = {ortamlar: [], yapilandirildi: false};

  acikTenantlar: KosuTenantSatiri[] = [];
  hataOnbellek: { [kosuTenantId: number]: TenantHataDurumu } = {};

  baglantiSorunu: boolean = false;
  sonPollHatasi: string = "";
  hizSiniri: boolean = false;

  /* ---------------- Durdur / Başlat onay diyaloğu ---------------- */
  durdurBaslatDialog: boolean = false;
  durdurBaslatTip: "durdur" | "baslat" | null = null;
  durdurBaslatIslemde: boolean = false;

  basliklar = [
    {text: "Durum", value: "durum", sortable: false, width: 140},
    {text: "Büro", value: "buro", sortable: false},
    {text: "İlerleme", value: "ilerleme", sortable: false, width: 220},
    {text: "Hesaplanan", value: "hesaplanan", sortable: false, width: 120},
    {text: "Veri eksik", value: "veri_eksik", sortable: false, width: 100},
    {text: "Hata", value: "hata", sortable: false, width: 90},
    {text: "Süre", value: "sure", sortable: false, width: 110},
    {text: "", value: "data-table-expand"}
  ];

  private zamanlayici: any = null;
  private geriCekilmeAdimi: number = 0;
  private retryAfterMs: number = 0;
  private gorunurlukDinleyicisi: any = null;
  private yokEdildi: boolean = false;
  /** Uçuştaki detay isteğini bayatlatmak için artan sıra numarası. */
  private istekSirasi: number = 0;
  /** Yoklama turunun kendi sırası — hızlı gizle/göster iki turu üst üste tetiklemesin. */
  private pollSirasi: number = 0;

  /* ---------------- hesaplananlar ---------------- */

  get baslik(): string {
    if (!this.detay) {
      return "";
    }
    return this.tarihGoster(this.detay.kosu.hesap_tarihi) + " gece koşusu";
  }

  get durumBilgisi() {
    return this.detay ? kosuDurumBilgisi(this.detay.kosu.durum) : null;
  }

  get tetikleyenMetni(): string {
    if (!this.detay) {
      return "";
    }
    const k = this.detay.kosu;
    if (k.tetikleyen_tip === "cron") {
      return "Otomatik başladı (gece zamanlayıcısı)";
    }
    return k.tetikleyen_ad ? ("Manuel başlattı: " + k.tetikleyen_ad) : "Manuel olarak başlatıldı";
  }

  /** Rotadaki ?ortam= değeri; yoksa boş (ortamBul listedeki ilk ortamı seçer). */
  private get ortamSorguDegeri(): string {
    const q = this.$route.query.ortam;
    return typeof q === "string" ? q : "";
  }

  get seciliOrtamEtiketi(): string {
    if (this.ortamListesi.ortamlar.length === 0) {
      return "";
    }
    return ortamBul(this.ortamListesi, this.ortamSorguDegeri).etiket;
  }

  /** {seçili API}admin/gece-kosusu/ — sonunda "/" ile. Liste kurulmadan önce panelin kendi API'si. */
  private get geceKosusuTabani(): string {
    const api = this.ortamListesi.ortamlar.length === 0
        ? this.$store.state.icwApiUrl
        : ortamBul(this.ortamListesi, this.ortamSorguDegeri).apiUrl;
    return api + "admin/gece-kosusu/";
  }

  /**
   * ÖLÇÜM NOTU (gerçek bir koşuyla doğrulandı — toplam_tenant=26,
   * tamamlanan_tenant=26, atlanan_tenant=13, hatali_tenant=0): tamamlanan_tenant
   * sayacı atlanan VE hatalı tenant'ları ZATEN İÇERİR; ayrıca toplanmaz. Yani
   * doğru yüzde tamamlanan_tenant / toplam_tenant'tır — atlanan/hatali eklenirse
   * %150 gibi imkânsız değerler çıkar. Bu satırı "düzeltmeye" kalkışmayın.
   */
  get tenantYuzdesi(): number {
    if (!this.detay) {
      return 0;
    }
    return yuzde(this.detay.kosu.tamamlanan_tenant, this.detay.kosu.toplam_tenant);
  }

  get ilerlemeRengi(): string {
    if (!this.detay) {
      return "grey";
    }
    if (this.detay.kosu.hatali_tenant > 0) {
      return "warning";
    }
    return this.tenantYuzdesi >= 100 ? "success" : "info";
  }

  /** Yalnızca 'calisiyor' iken — tahmin ve şerit animasyonu bu duruma bağlı. */
  get kosuCalisiyor(): boolean {
    return this.detay !== null && this.detay.kosu.durum === "calisiyor";
  }

  /** 'calisiyor', 'beklemede' veya 'durduruluyor' iken yoklama sürer. */
  get kosuAktif(): boolean {
    return this.detay !== null
        && (this.detay.kosu.durum === "calisiyor"
            || this.detay.kosu.durum === "beklemede"
            || this.detay.kosu.durum === "durduruluyor");
  }

  /**
   * Bugünün tarihi ("YYYY-MM-DD"), yerel saat diliminde — Başlat düğmesi için
   * hesap_tarihi karşılaştırması. YÖNTEM (getter DEĞİL) olarak tanımlı:
   * vue-class-component getter'ları reaktif olmayan bağımlılıkla (yalnız
   * `new Date()`) sonsuza dek önbelleğe alınan bir computed'e çevirir — sekme
   * gece yarısını aşarak açık kalırsa tarih donuk kalır ve Başlat düğmesi
   * yanlışlıkla gizli kalırdı (bkz. R1: "yalnız hesap_tarihi bugünse").
   */
  private bugununTarihi(): string {
    const d = new Date();
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0")
        + "-" + String(d.getDate()).padStart(2, "0");
  }

  /** Sunucu Durdur/Başlat uçlarına izin veriyor mu (manuel_acik + admin-auth.api_url) — bkz. GeceKosusuPanelGuard. */
  private get durdurBaslatIzinli(): boolean {
    return !!(this.detay && this.detay.yetenekler
        && this.detay.yetenekler.durdur_baslat && this.detay.yetenekler.manuel_tetikleme);
  }

  /** Durdur düğmesi: yalnız 'tum' kapsamlı ve hâlâ ilerleyebilir bir koşuda, sunucu izin veriyorsa. */
  get durdurGosterilsin(): boolean {
    if (!this.detay) {
      return false;
    }
    const k = this.detay.kosu;
    return k.kapsam === "tum"
        && (k.durum === "calisiyor" || k.durum === "beklemede")
        && this.durdurBaslatIzinli;
  }

  /** Başlat düğmesi: yalnız 'tum' kapsamlı, durmuş/kesilmiş VE bugünkü bir koşuda. */
  get baslatGosterilsin(): boolean {
    if (!this.detay) {
      return false;
    }
    const k = this.detay.kosu;
    if (k.kapsam !== "tum" || (k.durum !== "durduruldu" && k.durum !== "kesildi")) {
      return false;
    }
    if (!this.durdurBaslatIzinli) {
      return false;
    }
    return k.hesap_tarihi === this.bugununTarihi();
  }

  /** Yetenekler alanındaki otomatik devam azamisi; eski API'lerde varsayılan 3. */
  get otomatikDevamAzami(): number {
    return (this.detay && this.detay.yetenekler && this.detay.yetenekler.otomatik_devam_azami) || 3;
  }

  /** Koşu üst üste otomatik devam azamisine ulaşıp 'kesildi'yse ayrı bir uyarı metni gösterilir. */
  get otomatikDevamKesildiMetni(): string {
    if (!this.detay) {
      return "";
    }
    const sayi = this.detay.kosu.otomatik_devam_sayisi || 0;
    if (this.detay.kosu.durum === "kesildi" && sayi >= this.otomatikDevamAzami) {
      return this.otomatikDevamAzami + " kez kesildi, otomatik devam durdu";
    }
    return "";
  }

  get tahminMetniGoster(): string {
    return this.detay ? tahminMetni(this.detay) : "";
  }

  get tahminKaba(): boolean {
    return this.detay !== null && this.detay.tahmin.tahmin_guveni === "kaba";
  }

  /** Henüz hiç veri yoksa (ilk yükleme hatası dahil) veya koşu aktifse yoklama sürmeli. */
  private get pollingGerekli(): boolean {
    if (this.bulunamadi) {
      return false;
    }
    if (this.detay === null) {
      return true;
    }
    return this.kosuAktif;
  }

  get yenilemeGostergesi(): string {
    if (!this.baglantiSorunu) {
      return "";
    }
    const saniye = Math.round(this.sonrakiGecikme() / 1000);
    return this.hizSiniri
        ? "Hız sınırı — yenileme duraklatıldı (" + saniye + " sn)"
        : "Bağlantı sorunu — yenileme yavaşlatıldı (" + saniye + " sn)";
  }

  /* ---------------- şablon yardımcıları ---------------- */

  tenantDurumMeta(durum: string) {
    return tenantDurumBilgisi(durum as any);
  }

  buroAdi(item: KosuTenantSatiri): string {
    return tenantGoruntuAdi(item);
  }

  tenantYuzdeHesapla(item: KosuTenantSatiri): number {
    return yuzde(item.gorulen_takip, item.toplam_takip);
  }

  tenantIlerlemeRengi(item: KosuTenantSatiri): string {
    if (item.durum === "hata") {
      return "error";
    }
    if (item.hata_sayisi > 0) {
      return "warning";
    }
    return item.durum === "bitti" ? "success" : "info";
  }

  atlanmaNedeniMetni(item: KosuTenantSatiri): string {
    if (item.atlanma_nedeni === "lisans_yok") {
      return "Aktif lisans yok";
    }
    if (item.atlanma_nedeni === "db_yok") {
      return "Veritabanı yok";
    }
    return "Atlandı";
  }

  sureGoster(item: KosuTenantSatiri): string {
    const ms = item.toplam_sure_ms;
    if (ms === null || ms === undefined) {
      return sureMetni(null);
    }
    return sureMetni(Math.round(ms / 1000));
  }

  sayiFormat(n: number | null | undefined): string {
    if (n === null || n === undefined || isNaN(n)) {
      return "0";
    }
    return n.toLocaleString("tr-TR");
  }

  tarih(deger: string | null): string {
    return formatDateTime(deger);
  }

  hataTipiEtiketiGoster(t: string): string {
    return hataTipiEtiketi(t as any);
  }

  hataTipiRengi(t: string): string {
    return HATA_TIPI_RENK[t] || "grey";
  }

  veriEksikMi(t: string): boolean {
    return veriEksikTipiMi(t);
  }

  /** hesap_tarihi "YYYY-MM-DD" biçiminde, saat bilgisi taşımaz — elle biçimlenir. */
  private tarihGoster(d: string | null | undefined): string {
    if (!d) {
      return "";
    }
    const parcalar = d.split("-");
    if (parcalar.length !== 3) {
      return d;
    }
    return parcalar[2] + "." + parcalar[1] + "." + parcalar[0];
  }

  hataDurum(item: KosuTenantSatiri): TenantHataDurumu {
    return this.hataOnbellek[item.id] || BOS_HATA_DURUM;
  }

  /* ---------------- veri çekme: koşu detayı ---------------- */

  async detayGetir(arkaplan: boolean = false): Promise<void> {
    if (this.kosuId === null) {
      return;
    }
    const sira = ++this.istekSirasi;
    if (!arkaplan) {
      this.yukleniyor = true;
      this.yuklemeHatasi = "";
    }
    try {
      const yanit = await this.$http.get(this.geceKosusuTabani + this.kosuId);
      if (sira !== this.istekSirasi) {
        return; // bayat yanıt: daha yenisi geldi
      }
      const veri = yanit.data && yanit.data.data ? yanit.data.data : null;
      if (!veri) {
        throw new Error("Sunucu yanıtı beklenen biçimde değil.");
      }
      this.detayUygula(veri as KosuDetay);
      this.bulunamadi = false;
    } catch (e) {
      if (sira !== this.istekSirasi) {
        return; // bayat hata: taze başarılı durumu bozmasın
      }
      const durum = e && e.response ? e.response.status : 0;
      if (durum === 404) {
        this.bulunamadi = true;
        this.detay = null;
        this.zamanlayiciTemizle();
        return; // terminal: yeniden denemeye gerek yok
      }
      if (!arkaplan) {
        this.yuklemeHatasi = this.hataMesaji(e);
      }
      throw e; // yoklama döngüsü geri çekilmeyi uygulayabilsin
    } finally {
      if (sira === this.istekSirasi) {
        this.yukleniyor = false;
      }
    }
  }

  /**
   * Yeni veri geldiğinde tüm diziyi değiştirmek güvenlidir: Vuetify
   * `expanded` eşleşmesini item-key DEĞERİNE göre yapar (nesne referansına
   * göre değil), bu yüzden açık akordiyonlar dizinin yenilenmesiyle kapanmaz.
   */
  private detayUygula(veri: KosuDetay) {
    if (!Array.isArray(veri.tenantlar)) {
      veri.tenantlar = [];
    }
    this.detay = veri;
  }

  /* ---------------- tenant hata listesi (akordiyon) ---------------- */

  tenantGenisletildi(payload: { item: KosuTenantSatiri; value: boolean }) {
    if (!payload.value) {
      return; // yalnızca AÇILIRKEN yükle
    }
    const item = payload.item;
    const mevcut = this.hataOnbellek[item.id];
    // Koşu çalışıyorken hâlâ işlenmekte olan tenant için her açılışta tazele;
    // diğer her durumda önbellekteki veri yeterli — tekrar istek atma.
    const tazelenmeliMi = this.kosuCalisiyor && item.durum === "isleniyor";
    if (mevcut && mevcut.yuklendi && !tazelenmeliMi) {
      return;
    }
    this.tenantHatalariGetir(item, 1, false);
  }

  dahaFazlaHataYukle(item: KosuTenantSatiri) {
    const mevcut = this.hataOnbellek[item.id];
    const sonrakiSayfa = mevcut ? mevcut.sayfa + 1 : 1;
    this.tenantHatalariGetir(item, sonrakiSayfa, true);
  }

  private async tenantHatalariGetir(item: KosuTenantSatiri, sayfa: number, ekle: boolean): Promise<void> {
    if (this.kosuId === null) {
      return;
    }
    let durum = this.hataOnbellek[item.id];
    if (!durum) {
      durum = {
        yukleniyor: false, yukleniyorDaha: false, hata: "", liste: [],
        sayfa: 0, dahaVar: false, yuklendi: false, sira: 0
      };
      this.$set(this.hataOnbellek, item.id, durum);
    }
    const sira = ++durum.sira;
    if (ekle) {
      durum.yukleniyorDaha = true;
    } else {
      durum.yukleniyor = true;
      durum.hata = "";
    }
    try {
      const yanit = await this.$http.get(
          this.geceKosusuTabani + this.kosuId + "/tenant/" + item.id + "/hatalar",
          {params: {page: sayfa, per_page: 50}}
      );
      if (sira !== durum.sira) {
        return; // bayat yanıt: tenant kapatılıp yeniden açılmış olabilir
      }
      const govde = yanit.data || {};
      const gelenler: KosuHataSatiri[] = Array.isArray(govde.data) ? govde.data : [];
      durum.liste = ekle ? durum.liste.concat(gelenler) : gelenler;
      durum.sayfa = sayfa;
      const sonSayfa = govde.last_page || sayfa;
      durum.dahaVar = sayfa < sonSayfa;
      durum.yuklendi = true;
    } catch (e) {
      if (sira !== durum.sira) {
        return;
      }
      durum.hata = this.hataMesaji(e);
      if (ekle) {
        // "Daha fazla göster" başarısız oldu: eldeki liste korunur, yalnızca
        // hata gösterilmesin diye üstteki hata alanı burada boş bırakılır —
        // kullanıcı listedeki mevcut kayıtları kaybetmesin.
        durum.hata = "";
        this.$toast.error(this.hataMesaji(e));
      }
    } finally {
      if (sira === durum.sira) {
        durum.yukleniyor = false;
        durum.yukleniyorDaha = false;
      }
    }
  }

  /**
   * Başlıktaki "{{ hata_sayisi }} hata" sayacı her poll turunda taze detaydan
   * canlı güncellenir, ama akordiyon açıkken içindeki hata LİSTESİ tazelenmiyordu
   * — tenant hâlâ işlenirken kullanıcı akordiyonu açık bırakırsa başlık "5 hata"
   * derken tabloda 2 satır kalabiliyordu. Koşu 'calisiyor' iken, AÇIK olan ve
   * durumu hâlâ 'isleniyor' olan tenant'lar için ilk sayfayı yeniden çeker.
   * Kullanıcı "Daha fazla göster" ile ek sayfa yüklediyse o tenant için tazeleme
   * ATLANIR — aksi halde sayfalanmış liste birden küçülüp kullanıcıyı şaşırtır.
   */
  private acikIsleyenTenantlariTazele() {
    if (!this.detay || this.detay.kosu.durum !== "calisiyor") {
      return;
    }
    for (const acikItem of this.acikTenantlar) {
      // detayUygula tüm tenantlar dizisini değiştirir; acikItem bayat referans
      // olabilir, bu yüzden güncel satır id'ye göre yeniden bulunur.
      const guncel = this.detay.tenantlar.find(t => t.id === acikItem.id);
      if (!guncel || guncel.durum !== "isleniyor") {
        continue;
      }
      const mevcutDurum = this.hataOnbellek[guncel.id];
      if (mevcutDurum && mevcutDurum.sayfa > 1) {
        continue; // birden fazla sayfa yüklenmiş: tazelemeyi atla
      }
      this.tenantHatalariGetir(guncel, 1, false);
    }
  }

  /* ---------------- otomatik yenileme ---------------- */

  private async pollTuru() {
    if (this.sekmeGizli() || this.yokEdildi) {
      return;
    }
    const sira = ++this.pollSirasi;
    try {
      await this.detayGetir(true);
      if (sira !== this.pollSirasi) {
        return;
      }
      this.pollBasarili();
      this.acikIsleyenTenantlariTazele();
    } catch (e) {
      if (sira !== this.pollSirasi) {
        return;
      }
      if (!this.bulunamadi) {
        this.pollHatasi(e);
      }
    }
    if (sira === this.pollSirasi) {
      this.zamanla();
    }
  }

  private pollBasarili() {
    this.baglantiSorunu = false;
    this.hizSiniri = false;
    this.geriCekilmeAdimi = 0;
    this.retryAfterMs = 0;
  }

  private pollHatasi(e: any) {
    const durum = e && e.response ? e.response.status : 0;
    this.baglantiSorunu = true;
    this.sonPollHatasi = this.hataMesaji(e);

    if (durum === 429) {
      this.hizSiniri = true;
      this.retryAfterMs = this.retryAfterOku(e);
      this.geriCekilmeAdimi = Math.min(this.geriCekilmeAdimi + 1, GECIKME_BASAMAKLARI.length - 1);
      return;
    }

    // Ağ / 5xx: TenantHavuzu.vue'daki gibi 429'dan bir basamak daha ölçülü geri
    // çekil (burada 40 sn'de dur, tavan 60 sn'ye çıkmaz) — Retry-After burada
    // geçerli değil, sunucu kastenmiş bir bekleme süresi bildirmiyor.
    this.retryAfterMs = 0;
    this.geriCekilmeAdimi = Math.min(this.geriCekilmeAdimi + 1, GECIKME_BASAMAKLARI.length - 2);
  }

  private retryAfterOku(e: any): number {
    const basliklar = e && e.response ? e.response.headers : null;
    if (!basliklar) {
      return 0;
    }
    const ham = basliklar["retry-after"] || basliklar["Retry-After"];
    if (!ham) {
      return 0;
    }
    const saniye = parseInt(String(ham), 10);
    if (isNaN(saniye) || saniye <= 0) {
      return 0;
    }
    return Math.min(saniye * 1000, AZAMI_RETRY_AFTER);
  }

  private zamanla() {
    this.zamanlayiciTemizle();
    if (this.yokEdildi || this.sekmeGizli() || !this.pollingGerekli) {
      return;
    }
    this.zamanlayici = setTimeout(() => this.pollTuru(), this.sonrakiGecikme());
  }

  private sonrakiGecikme(): number {
    if (this.retryAfterMs > 0) {
      return this.retryAfterMs;
    }
    return GECIKME_BASAMAKLARI[Math.min(this.geriCekilmeAdimi, GECIKME_BASAMAKLARI.length - 1)];
  }

  private sekmeGizli(): boolean {
    return typeof document !== "undefined" && document.visibilityState === "hidden";
  }

  private gorunurlukDegisti() {
    if (this.sekmeGizli()) {
      this.zamanlayiciTemizle();
      return;
    }
    if (!this.yokEdildi) {
      this.zamanlayiciTemizle();
      this.pollTuru();
    }
  }

  private zamanlayiciTemizle() {
    if (this.zamanlayici !== null) {
      clearTimeout(this.zamanlayici);
      this.zamanlayici = null;
    }
  }

  /* ---------------- eylemler ---------------- */

  listeyeDon() {
    const query = this.ortamListesi.yapilandirildi
        ? {ortam: ortamBul(this.ortamListesi, this.ortamSorguDegeri).anahtar}
        : {};
    this.$router.push({path: "/icraproWeb/gece-kosusu", query: query});
  }

  async elleYenile() {
    if (this.kosuId === null) {
      this.baslat();
      return;
    }
    try {
      await this.detayGetir(false);
      this.pollBasarili();
      this.zamanla();
    } catch (e) {
      this.pollHatasi(e);
      this.zamanla();
    }
  }

  /* ---------------- Durdur / Başlat ---------------- */

  durdurOnayAc() {
    this.durdurBaslatTip = "durdur";
    this.durdurBaslatDialog = true;
  }

  baslatOnayAc() {
    this.durdurBaslatTip = "baslat";
    this.durdurBaslatDialog = true;
  }

  durdurBaslatKapat() {
    if (this.durdurBaslatIslemde) {
      return; // istek uçuştayken diyalog kapatılamaz
    }
    this.durdurBaslatDialog = false;
    this.durdurBaslatTip = null;
  }

  async durdurBaslatOnayla(): Promise<void> {
    if (this.kosuId === null || this.durdurBaslatTip === null) {
      return;
    }
    const tip = this.durdurBaslatTip;
    this.durdurBaslatIslemde = true;
    try {
      const yanit = await this.$http.post(this.geceKosusuTabani + this.kosuId + "/" + tip);
      const veri = (yanit.data && yanit.data.data) || {};
      if (tip === "durdur") {
        this.$toast.success("Durdurma istendi; o an hesaplanan takip bitince duracak.");
      } else {
        // Kuyruk modunda API süreç başlatmaz; koşucu sunucusundaki toplayıcı
        // satırı dakikada bir alır (bkz. yeniKosuGonder() — GeceKosusu.vue'daki
        // aynı ayrım).
        this.$toast.success(veri.tetikleme_modu === "kuyruk"
            ? "Koşu sıraya alındı; koşucu bir dakika içinde devam ettirecek."
            : "Koşu devam ettiriliyor.");
      }
      this.durdurBaslatDialog = false;
      this.durdurBaslatTip = null;

      // İyimser durum güncellemesi: sunucu isteği zaten BAŞARILI oldu, ama
      // hemen sonraki detayGetir() başarısız olabilir (geçici ağ sorunu, POST
      // sonrası hız sınırı vb.) — bu durumda bile pollingGerekli/kosuAktif'in
      // yeni durumu görmesi lazım, yoksa (özellikle Başlat'ta: durduruldu/
      // kesildi kosuAktif'te DEĞİL) hiçbir yoklama zamanlanmaz ve sayfa donuk
      // kalır (bkz. R1 Durdur -> durduruluyor, Başlat -> beklemede/calisiyor).
      if (this.detay) {
        this.detay.kosu.durum = tip === "durdur" ? "durduruluyor" : "beklemede";
      }

      await this.detayGetir(false);
      this.pollBasarili();
      this.zamanla();
    } catch (e) {
      this.$toast.error(this.hataMesaji(e));
      this.pollHatasi(e);
      this.zamanla();
    } finally {
      this.durdurBaslatIslemde = false;
    }
  }

  /* ---------------- hata biçimlendirme ---------------- */

  private hataMesaji(e: any): string {
    const yanit = e && e.response;
    if (!yanit) {
      return "Sunucuya ulaşılamadı.";
    }
    const govde = yanit.data || {};
    if (yanit.status === 500 && govde.reference) {
      return (govde.message || "İşlem başarısız.") + " (Destek için referans: " + govde.reference + ")";
    }
    if (yanit.status === 503) {
      return govde.message || "Gece koşusu uçları şu anda kullanılamıyor.";
    }
    if (yanit.status === 403) {
      return govde.message || "Bu ekranı görüntüleme yetkiniz yok.";
    }
    if (yanit.status === 401) {
      return govde.message || "Oturum doğrulanamadı.";
    }
    if (yanit.status === 429) {
      return "Hız sınırına ulaşıldı; kısa bir süre bekleyip tekrar deneyin.";
    }
    return govde.message || ("İstek başarısız (HTTP " + yanit.status + ").");
  }

  /* ---------------- yaşam döngüsü ---------------- */

  /**
   * İlk açılışta VE route parametresi (kosuId) ya da ortam sorgusu yerinde
   * değişince çağrılır — vue-router aynı bileşeni yeniden kullanır, `mounted()`
   * ikinci koşuda TETİKLENMEZ. Koşu değiştiğinde önceki koşunun önbelleği, açık
   * akordiyonları ve uçuştaki isteklerini bayatlatmadan devam etmek yanlış
   * veriyi göstermeye yol açar.
   */
  private baslat() {
    this.istekSirasi++;
    this.pollSirasi++;
    this.zamanlayiciTemizle();

    const raw = this.$route.params.kosuId;
    const parsed = raw ? parseInt(raw, 10) : NaN;
    this.kosuId = isNaN(parsed) ? null : parsed;
    this.bulunamadi = this.kosuId === null;
    this.detay = null;
    this.yuklemeHatasi = "";
    this.acikTenantlar = [];
    this.hataOnbellek = {};
    this.durdurBaslatDialog = false;
    this.durdurBaslatTip = null;
    this.durdurBaslatIslemde = false;
    this.pollBasarili();

    if (this.kosuId === null) {
      return;
    }
    this.detayGetir(false)
        .then(() => this.zamanla())
        .catch(e => {
          this.pollHatasi(e);
          this.zamanla();
        });
  }

  @Watch("$route.params.kosuId")
  onKosuIdDegisti(yeni: string, eski: string) {
    if (yeni === eski) {
      return;
    }
    this.baslat();
  }

  /** Aynı koşu başka bir ortamda açılırsa (ör. geri/ileri) veri o ortamın API'sinden yeniden çekilir. */
  @Watch("$route.query.ortam")
  onOrtamSorgusuDegisti(yeni: string, eski: string) {
    if (yeni === eski) {
      return;
    }
    this.baslat();
  }

  mounted() {
    this.ortamListesi = geceKosusuOrtamlari(this.$store.state.icwApiUrl);
    this.gorunurlukDinleyicisi = () => this.gorunurlukDegisti();
    document.addEventListener("visibilitychange", this.gorunurlukDinleyicisi);
    this.baslat();
  }

  beforeDestroy() {
    this.yokEdildi = true;
    this.zamanlayiciTemizle();
    if (this.gorunurlukDinleyicisi !== null) {
      document.removeEventListener("visibilitychange", this.gorunurlukDinleyicisi);
      this.gorunurlukDinleyicisi = null;
    }
  }
}
